// URL translations for job offer categories
import {
  ARCHITECTURE_CATEGORIES,
  ENGINEERING_CATEGORIES,
  CONSTRUCTION_CATEGORIES,
  ADMINISTRATION_CATEGORIES
} from './categoryData';

// Map of industry slugs in different languages
export const INDUSTRY_SLUGS = {
  architecture: {
    en: 'architecture',
    fr: 'architecture',
    nl: 'architectuur'
  },
  engineering: {
    en: 'engineering',
    fr: 'ingenierie',
    nl: 'ingenieurswetenschappen'
  },
  construction: {
    en: 'construction',
    fr: 'construction',
    nl: 'bouw'
  },
  administration: {
    en: 'administration',
    fr: 'administration',
    nl: 'administratie'
  }
};

// Helper function to get the translated industry slug
export const getIndustrySlug = (industry, locale) => {
  return INDUSTRY_SLUGS[industry]?.[locale] || INDUSTRY_SLUGS[industry]?.['en'];
};

// Helper function to get the translated category slug
export const getCategorySlug = (industry, category, locale) => {
  const categories = {
    architecture: ARCHITECTURE_CATEGORIES,
    engineering: ENGINEERING_CATEGORIES,
    construction: CONSTRUCTION_CATEGORIES,
    administration: ADMINISTRATION_CATEGORIES
  };

  // First try to find the category in the requested language
  const categoryInLocale = categories[industry]?.[locale]?.find(c => c.slug === category);
  if (categoryInLocale) {
    return categoryInLocale.slug;
  }

  // If not found, try to find the category in English and get its equivalent in the requested language
  const categoryInEnglish = categories[industry]?.['en']?.find(c => c.slug === category);
  if (categoryInEnglish) {
    const index = categories[industry]?.['en']?.indexOf(categoryInEnglish);
    return categories[industry]?.[locale]?.[index]?.slug || category;
  }

  return category;
};

// Helper function to get the English slug from a translated slug
export const getEnglishSlug = (industry, translatedSlug, locale) => {
  const categories = {
    architecture: ARCHITECTURE_CATEGORIES,
    engineering: ENGINEERING_CATEGORIES,
    construction: CONSTRUCTION_CATEGORIES,
    administration: ADMINISTRATION_CATEGORIES
  };

  // Find the category in the given language
  const categoryInLocale = categories[industry]?.[locale]?.find(c => c.slug === translatedSlug);
  if (categoryInLocale) {
    const index = categories[industry]?.[locale]?.indexOf(categoryInLocale);
    return categories[industry]?.['en']?.[index]?.slug || translatedSlug;
  }

  return translatedSlug;
};
